var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "button-wrapper" }, [
    _c(
      "button",
      {
        staticClass: "button",
        class: _vm.applyClasses,
        attrs: {
          tabindex: _vm.isTabbable,
          "aria-label": _vm.ariaLabel,
          disabled: _vm.disabled
        },
        on: { click: _vm.emitClick }
      },
      [
        _vm.animated
          ? _c(
              "div",
              { ref: "buttonIcon", staticClass: "button--animated-icon" },
              [_c("BaseIcon", { attrs: { icon: _vm.icon, size: "lg" } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "span",
          { ref: "buttonText", staticClass: "button--title" },
          [_vm._t("default"), _vm._v(_vm._s(_vm.title) + "\n            ")],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ab700c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ab700c7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseButton.vue
// module id = null
// module chunks = 